export function getFetchAccountsRequest (state, workspaceSlug, sourceSlug) {
  // Legacy sourceSlug's can contain dots
  const accountsByWorkspaceAndSourceSlug = state.accountsByWorkspaceAndSourceSlug || {}
  return accountsByWorkspaceAndSourceSlug[`fetch-${workspaceSlug}-${sourceSlug}`]
}

export function getUpdateAccountsRequest (state, workspaceSlug, sourceSlug) {
  // Legacy sourceSlug's can contain dots
  const accountsByWorkspaceAndSourceSlug = state.accountsByWorkspaceAndSourceSlug || {}
  return accountsByWorkspaceAndSourceSlug[`update-${workspaceSlug}-${sourceSlug}`]
}



// WEBPACK FOOTER //
// ./selectors/accounts.js